<template>
  <v-snackbar
    v-model="isOpen"
    app
    absolute
    bottom
    right
    multi-line
    timeout="-1"
    class="pa-0 mb-2 mr-2 z-1"
    max-width="400"
    max-height="300"
    :style="{
      'max-width': '450px',
    }"
  >
    <span class="display-3">Cookies Accept</span>

    <v-icon class="mx-2">
      mdi-cookie
    </v-icon>

    <p class="body-1 mt-2">
      We use cookies on this website to analyze traffic and optimize your experience.
      By browsing this website, you consent to the use of cookies listed in the
      <router-link
        :to="{ name: 'policies-cookies' }"
        class="simple-link"
      >
        privacy policy
      </router-link>.
    </p>

    <div class="px-0 pb-2 d-flex mx-n1">
      <v-btn
        color="secondary"
        width="150"
        class="mx-1"
        @click="decline"
      >
        Decline
      </v-btn>

      <v-btn
        color="primary"
        width="150"
        class="mx-1"
        @click="accept"
      >
        Accept
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
  export default {
    name: 'CookiesAccept',

    data() {
      return {
        isOpen: true,
      }
    },

    created() {
      console.log('CookiesAccept created')
    },

    methods: {
      accept() {
        localStorage.setItem('accept_cookies', true);
        this.$gtag.optIn();
        this.$emit('click:accept');
        this.$bus.$emit('accept:cookies');
        this.close();
      },

      decline() {
        localStorage.setItem('accept_cookies', false);
        this.$emit('click:decline');
        this.$bus.$emit('decline:cookies');
        this.close();
      },

      close() {
        this.isOpen = false;
      },
    },

  }
</script>